import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Colors } from "../../../../tools/color";

export const CardBox = styled(Box)(({ theme }) => ({
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    backgroundColor: "white",
}));

export const GrayCardBox = styled(Box)(({ theme }) => ({
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    backgroundColor: Colors["background3"],
}));

export const CardRoundBox = styled(Box)(({ theme }) => ({
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    backgroundColor: "white",
    borderRadius: "3px",
}));
